module.exports = "<div class=\"container check-browser-container\">\n    <div class=\"row\">\n        <div class=\"col-lg-8 col-lg-offset-2\">\n            <p><div class=\"logo center-block\"></div></p>\n            <p>Internet Explorer is not recommended, please download <a type=\"\" href=\"https://www.google.com/chrome/browser\" target=\"_blank\">Chrome</a></p>\n            <p>If you want to continue, click <a class=\"btn btn-link\" href=\"#\" ng-click=\"confirmContinue()\">here</a></p>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/check.browser.html
// module id = 834
// module chunks = 0